import { makeStyles } from '@material-ui/core/styles';

const linkDefault = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%',
  textTransform: 'uppercase',
};

const useStyles = makeStyles(
  (theme) => ({
    actionsContainer: {
      marginRight: '1.5rem',
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
    },
    iconButton: {
      height: '2.5rem',
      width: '2.5rem',
      display: 'flex',
    },
    image: {
      border: '2px solid black',
      height: '2.5rem',
      width: '2.5rem',
    },
    imageContainer: {
      height: '2.5rem',
      width: '2.5rem',
    },
    item: {
      width: '8.8125rem',
    },
    itemContainer: {
      display: 'flex',
    },
    link: {
      color: theme.palette.common.white,
      textDecoration: 'none',
      ...linkDefault,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
    },
    root: {
      backgroundColor: theme.palette.primary.xtraLight,
      fontSize: '1.125rem',
      height: '3.75rem',
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
    },
    selectedLink: {
      color: theme.palette.common.white,
      ...linkDefault,
      textDecoration: 'none',
      backgroundColor: theme.palette.secondary.main,
    },
    titleContainer: {
      marginLeft: '1.5rem',
      display: 'flex',
      alignItems: 'center',
      width: '16rem',
    },
  }),
  // This is due to a bug with the order in which the styles are loaded
  // https://github.com/mui-org/material-ui/issues/16609
  { index: 1 }
);

export default useStyles;
